module.exports = __webpack_public_path__ + "static/media/SostenibilitàSistemica_ASSETS-Fish_17.c9d29925.png";